export default {
  data: () => ({
    solution_map: {
      "retail": "Varejo",
      "10": "Varejo",
      "wholesale": "Grandes Cargas",
      "1": "Grandes Cargas",


      "rent": "Locação",
      "20": "Locação",

      "concrete": "Concreteira",
      "30": "Concreteira",

      "gas_station": "Postos de Combustíveis",
      "40": "Postos de Combustíveis",
    },
  }),
}